import { render, staticRenderFns } from "./AlertTooltip.vue?vue&type=template&id=385d80c8&"
import script from "./AlertTooltip.vue?vue&type=script&lang=ts&"
export * from "./AlertTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports